import React from 'react';
import CircuitsUsageChart from './CircuitUsageChart';
import PropTypes from 'prop-types';
import useI18n from '../../../../../../../i18n/useI18n';

const CircuitsUsage = (props) => {
    const { tViews } = useI18n('views');

    return (
        <div
            role="region"
            aria-label={tViews('usageBasedAD.usageTabHeader')}
        >
            {props.selectedtrendCircuits &&
                <CircuitsUsageChart
                    selectedtrendCircuits={props.selectedtrendCircuits}
                    isPrevUsgList={props.isPrevUsgList}
                    prevCircuitUsageList={props.prevCircuitUsageList}
                    selectedHour={props.selectedHour}
                    cuiProps={props.cuiProps}
                />}
        </div>
    )
}

CircuitsUsage.propTypes = {
    selectedHour: PropTypes.string,
    cuiProps: PropTypes.object,
    refresh: PropTypes.bool,
    saveSelectedTrendCircuits: PropTypes.func,
    selectedtrendCircuits: PropTypes.array,
    isPrevUsgList: PropTypes.func,
    prevCircuitUsageList: PropTypes.array
};


export default CircuitsUsage;
